module.exports = "<div class=gmw-messages-folder-item> <a href class=gmw-messages-folder-item__body ui-sref=\"holding.dashboard.messages.news.message({\n      messageId: message.code\n    })\"> <span class=\"gmw-messages-folder-item__title h-default-text\" ng-bind=message.title|holdingStripHtml> </span> <span ng-bind=\"message.ts|gmwFormatDate:'MMMM DD, YYYY'\"></span> </a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/messages/directives/messages-folder-list-news-item/messages-folder-list-news-item.html
// module id = 720
// module chunks = 0